export default __webpack_public_path__ + "static/media/delete.74de4ffb.png";